module.exports = __webpack_public_path__ + "assets/svg/Icons/32/timesheet-gray-620dd7.svg";